// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updateBidProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitUpdateBidProfessionalApi = createAsyncThunk("hitUpdateBidProfessionalApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + updateBidProfessional;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const UpdateBidProfessionalSlice = createSlice({
  name: "updateBidProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdateBidProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateBidProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateBidProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateBidProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdateBidProfessionalData } = UpdateBidProfessionalSlice.actions;
export default UpdateBidProfessionalSlice.reducer;
